import script from "./personal-settlement.vue?vue&type=script&setup=true&lang=js"
export * from "./personal-settlement.vue?vue&type=script&setup=true&lang=js"

import "./personal-settlement.vue?vue&type=style&index=0&id=5e96105c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e96105c"]])

export default __exports__